import React from 'react';

function Step(props){
  return(
    <p>{props.stepNum}. {props.stepDesc}</p>
  )
}

export default Step;